import React from 'react';
import { Typography, IconButton, Stack, TypographyProps } from '@mui/material';
import { InfoRounded } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';

interface TextWithIconProps {
    text: string | number;
    onClick?: () => void;
    icon?: JSX.Element;
    rightIcon?: JSX.Element;
    onMenuPressed?: () => void;
    typographyProps?: TypographyProps;
    mainStyle?: React.CSSProperties;
}

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
    },
    text: {
        color: 'white',
    },
    iconButton: {
        color: 'white',
        marginRight: 20,
        fontSize: '1.2rem',
    },
    rightIcon: {
        alignItems: 'center',
        justifyContent: 'space-between',
    },
});

const TextWithIcon: React.FC<TextWithIconProps> = ({
    text,
    onClick,
    icon,
    rightIcon,
    onMenuPressed,
    typographyProps,
    mainStyle,
}) => {
    const classes = useStyles();
    const { themeStyle } = useThemeContext();

    const handleOnClick = () => {
        onClick && onClick();
    };

    return (
        <div className={classes.rightIcon} style={mainStyle}>
            <Stack direction="row" alignItems="center" gap={0.5} style={{ flexWrap: 'wrap' }}>
                {icon ?? <InfoRounded />}
                <Typography
                    fontSize={18}
                    fontFamily={FONT_ENUM.MAIN_BOLD}
                    color={theme[themeStyle].tag_white}
                    {...typographyProps}
                    style={{ flex: 1 }}>
                    {text}
                </Typography>
            </Stack>
            {rightIcon && (
                <IconButton size="small" className={classes.iconButton} onClick={handleOnClick}>
                    {rightIcon}
                </IconButton>
            )}
        </div>
    );
};

TextWithIcon.defaultProps = {
    text: 'Menu item here',
    icon: <InfoRounded />,
};

export { TextWithIcon };
